import { Component, Input } from '@angular/core'
import { AutosizeIframeDirective } from 'src/app/directives/autosize-iframe.directive'
import { SafePipe } from 'src/app/pipes/safe.pipe'
import { NgClass } from '@angular/common'
import { PageContext, Redirector4SaleConfig } from 'src/app/service/redirector.service'
import { UserTokenPipe } from 'src/app/pipes/promo-link.pipe'

@Component({
  imports: [
    AutosizeIframeDirective,
    SafePipe,
    NgClass,
    UserTokenPipe,
  ],
  selector: 'app-contactform',
  templateUrl: './contactform.component.html',
  styleUrl: './contactform.component.sass',
})
export class ContactformComponent {
  @Input({ required: true }) context!: PageContext<Redirector4SaleConfig>
}
